import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, Mail } from 'lucide-react';

function SubscriptionCancel() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#070910] text-slate-200 flex items-center justify-center p-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="max-w-2xl w-full"
            >
                <div className="bg-[#0D111C] border border-white/10 rounded-3xl p-12 text-center backdrop-blur-md">
                    {/* Cancel Icon */}
                    <div className="w-20 h-20 bg-orange-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                        <XCircle className="w-12 h-12 text-orange-400" />
                    </div>

                    {/* Title */}
                    <h1 className="text-4xl font-black text-white mb-4">
                        Payment Cancelled
                    </h1>

                    <p className="text-lg text-slate-400 mb-8">
                        No worries! Your payment was not processed. You can try again whenever you're ready.
                    </p>

                    {/* Info Box */}
                    <div className="bg-[#161B2E] rounded-2xl p-6 mb-8 text-left border border-white/5">
                        <h2 className="text-xl font-bold text-white mb-4">Need Help?</h2>
                        <p className="text-slate-300 mb-4">
                            If you encountered any issues during checkout or have questions about our pricing:
                        </p>
                        <ul className="space-y-2 text-slate-400 text-sm">
                            <li>• Review our pricing plans and features</li>
                            <li>• Contact our support team for assistance</li>
                            <li>• Request a free trial for qualified customers</li>
                        </ul>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button
                            onClick={() => navigate('/pricing')}
                            className="px-8 py-4 bg-orange-600 hover:bg-orange-500 text-white rounded-xl font-bold transition-all shadow-lg shadow-orange-900/30 flex items-center justify-center gap-2"
                        >
                            <ArrowLeft className="w-5 h-5" />
                            Back to Pricing
                        </button>
                        <a
                            href="mailto:support@lashingcalculator.com"
                            className="px-8 py-4 bg-[#161B2E] hover:bg-[#1E253A] text-white rounded-xl font-bold transition-all flex items-center justify-center gap-2 border border-white/10"
                        >
                            <Mail className="w-5 h-5" />
                            Contact Support
                        </a>
                    </div>

                    {/* Help Text */}
                    <p className="text-sm text-slate-500 mt-8">
                        Your data is safe. Nothing was charged to your account.
                    </p>
                </div>
            </motion.div>
        </div>
    );
}

export default SubscriptionCancel;
